export default __webpack_public_path__ + "static/media/scrollcard2.622a9800.jpg";